import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal wrapper
export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.985 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Eyebrow label used above section headings
export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-teal ${className}`}
  >
    <span className="h-px w-6 bg-teal" />
    {children}
  </span>
);
